import React from 'react'
import ImRadioChecked from '@meronex/icons/im/ImRadioChecked'
import ImRadioUnchecked from '@meronex/icons/im/ImRadioUnchecked'
import { METHOD_TYPE } from '../../../global/const'

import {
  Container,
  RadioButtonWrapper
} from './styles'

export const FilterStatus = (props) => {
  const {
    method,
    onChangeMethod
  } = props

  const statusList = [
    { key: METHOD_TYPE.DIRECT_SALE, name: 'Direct Sale' },
    { key: METHOD_TYPE.AUCTION, name: 'Auction' },
    { key: METHOD_TYPE.UNLISTED, name: 'Unlisted' }
  ]

  const handleChangeMethod = (value) => {
    onChangeMethod(value)
  }

  return (
    <Container>
      {statusList.map(status => (
        <RadioButtonWrapper
          key={status.key}
          active={method === status.key}
          onClick={() => handleChangeMethod(status.key)}
        >
          {method === status.key ? <ImRadioChecked /> : <ImRadioUnchecked />}
          <span>{status.name}</span>
        </RadioButtonWrapper>
      ))}
    </Container>
  )
}
